module.exports = __webpack_public_path__ + "static/media/teacher22.476b3546.png";